import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ErrorStateProps {
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="font-outfit max-w-4xl flex justify-center md:mt-10">
      <div className="shadow-lg w-96 bg-white rounded-3xl p-2">
        <div className="px-4 py-8 md:p-8">
          <div className="flex flex-col justify-center items-center mt-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-20 h-20"
              viewBox="0 0 89 88"
              fill="none"
              aria-hidden="true"
            >
              <circle
                cx="44.5"
                cy="44"
                r="43"
                fill="#FF8E6A"
                stroke="#B83810"
                strokeWidth="2"
              />
              <path
                d="M44.5001 86C67.6961 86 86.5001 67.196 86.5001 44C86.5001 38.5056 79.9926 39.2296 78.1424 44.4031C65.7023 79.1877 24.3165 82.0967 5.07031 58.5C10.9748 74.551 26.4004 86 44.5001 86Z"
                fill="#FF3D00"
              />
              <path
                d="M44.5002 34.949L33.7522 24.201C31.2528 21.7017 27.2005 21.7017 24.7012 24.201C22.2018 26.7004 22.2018 30.7526 24.7012 33.252L35.4492 44L24.7012 54.748C22.2018 57.2474 22.2018 61.2996 24.7012 63.799C27.2005 66.2983 31.2528 66.2983 33.7522 63.799L44.5002 53.051L55.2482 63.799C57.7476 66.2983 61.7998 66.2983 64.2992 63.799C66.7985 61.2996 66.7985 57.2474 64.2992 54.748L53.5511 44L64.2992 33.252C66.7985 30.7526 66.7985 26.7004 64.2992 24.201C61.7998 21.7017 57.7476 21.7017 55.2482 24.201L44.5002 34.949Z"
                fill="#FFE5DD"
                stroke="#B83810"
                strokeWidth="2"
              />
            </svg>
            <h3 className="py-4 text-3xl font-semibold">
              {t("auth.forgot_password.error_state.title")}
            </h3>
            {/* <p className="text-center">
              Your reset code has expired.{" "}
              <button
                onClick={onRetry}
                className="text-teal-600 hover:text-teal-700 focus:outline-none focus:underline"
              >
                Request a new code
              </button>
            </p> */}

            <p className="text-center">
              {t("auth.forgot_password.error_state.message_prefix")}{" "}
              <span
                onClick={() => navigate(`/login`)}
                className="text-brand cursor-pointer"
              >
                {t("auth.forgot_password.error_state.login_link_text")}
              </span>{" "}
              {t("auth.forgot_password.error_state.message_middle")}{" "}
              <span onClick={onRetry} className="text-brand cursor-pointer">
                {t("auth.forgot_password.error_state.request_link_text")}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CreatePasswordErrorState: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="font-outfit max-w-4xl flex justify-center md:mt-10">
      <div className="shadow-lg w-96 bg-white rounded-3xl p-2">
        <div className="px-4 py-8 md:p-8">
          <div className="flex flex-col justify-center items-center mt-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-20 h-20"
              viewBox="0 0 89 88"
              fill="none"
              aria-hidden="true"
            >
              <circle
                cx="44.5"
                cy="44"
                r="43"
                fill="#FF8E6A"
                stroke="#B83810"
                strokeWidth="2"
              />
              <path
                d="M44.5001 86C67.6961 86 86.5001 67.196 86.5001 44C86.5001 38.5056 79.9926 39.2296 78.1424 44.4031C65.7023 79.1877 24.3165 82.0967 5.07031 58.5C10.9748 74.551 26.4004 86 44.5001 86Z"
                fill="#FF3D00"
              />
              <path
                d="M44.5002 34.949L33.7522 24.201C31.2528 21.7017 27.2005 21.7017 24.7012 24.201C22.2018 26.7004 22.2018 30.7526 24.7012 33.252L35.4492 44L24.7012 54.748C22.2018 57.2474 22.2018 61.2996 24.7012 63.799C27.2005 66.2983 31.2528 66.2983 33.7522 63.799L44.5002 53.051L55.2482 63.799C57.7476 66.2983 61.7998 66.2983 64.2992 63.799C66.7985 61.2996 66.7985 57.2474 64.2992 54.748L53.5511 44L64.2992 33.252C66.7985 30.7526 66.7985 26.7004 64.2992 24.201C61.7998 21.7017 57.7476 21.7017 55.2482 24.201L44.5002 34.949Z"
                fill="#FFE5DD"
                stroke="#B83810"
                strokeWidth="2"
              />
            </svg>
            <h3 className="py-4 text-3xl font-semibold">
              {t("auth.forgot_password.create_password_error.title")}
            </h3>
            <p className="text-center">
              {t("auth.forgot_password.create_password_error.message_prefix")}{" "}
              <span
                onClick={() => navigate(`/login`)}
                className="text-brand cursor-pointer"
              >
                {t(
                  "auth.forgot_password.create_password_error.login_link_text",
                )}
              </span>{" "}
              {t("auth.forgot_password.create_password_error.message_suffix")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoadingState: React.FC = () => (
  <div className="font-outfit max-w-4xl flex justify-center md:mt-10">
    <div className="shadow-lg w-96 bg-white rounded-3xl p-2">
      <div className="space-y-4 px-4 py-8 md:p-8">
        <div className="h-4 animate-pulse bg-gray-200 rounded w-1/4" />
        <div className="h-10 animate-pulse bg-gray-200 rounded" />
        <div className="h-10 animate-pulse bg-gray-200 rounded" />
        <div className="flex space-x-4">
          <div className="h-10 animate-pulse bg-gray-200 rounded w-1/2" />
          <div className="h-10 animate-pulse bg-gray-200 rounded w-1/2" />
        </div>
      </div>
    </div>
  </div>
);

export const Benefits: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    t("auth.forgot_password.benefits.tax_free_growth"),
    t("auth.forgot_password.benefits.employer_match"),
    t("auth.forgot_password.benefits.auto_setup"),
  ];

  return (
    <div className="hidden md:flex w-1/2 pr-8 flex-col justify-center">
      <h2 className="text-2xl mb-4">
        {t("auth.forgot_password.benefits.title")}
      </h2>
      <ul className="space-y-2">
        {benefits.map((benefit) => (
          <li key={benefit} className="flex items-center py-2">
            <svg
              className="w-5 h-5 text-green-500 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
};
